import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/invoices/', { params });
  },
  listFilters() {
    return Backend.get('/invoices/filters');
  },
  classifiers() {
    return Backend.get('/invoices/classifiers');
  },
  createData() {
    return Backend.get('/invoices/create');
  },
  editData(id) {
    return Backend.get(`/invoices/${id}/edit`);
  },
  mediaList(id) {
    return Backend.get(`/invoices/${id}/media`);
  },
  create(createData) {
    return Backend.post('/invoices/', createData);
  },
  update(id, updateData) {
    return Backend.put(`/invoices/${id}`, updateData);
  },
  addAttachment(id, file) {
    return Backend.post(`/invoices/${id}/attach-file`, file);
  },
  addFtpAttachment(id, path) {
    return Backend.post(`/invoices/${id}/attach-file-ftp`, { filepath: path });
  },
  deleteAttachment(invoiceId, attachmentId) {
    return Backend.delete(`/invoices/${invoiceId}/delete-file/${attachmentId}`);
  },
  fileFetcher(url, mimeType) {
    return Backend.get(`${url}`, {
      responseType: 'arraybuffer',
      headers: {
        Accept: mimeType,
      }
    });
  },
  itemsList(id) {
    return Backend.get(`/invoices/${id}/items`);
  },
  itemsUpdate(invoiceId, itemId, updateData) {
    return Backend.put(`/invoices/${invoiceId}/items/${itemId}`, updateData);
  },
  detainedPayment(invoiceId, updateData) {
    return Backend.put(`/invoices/${invoiceId}/detained-payment`, updateData);
  },
  approvePayment(invoiceId, approvalData) {
    return Backend.put(`/invoices/${invoiceId}/approve-payment`, approvalData);
  },
  rejectPayment(invoiceId, rejectData) {
    return Backend.put(`/invoices/${invoiceId}/decline-payment`, rejectData);
  },
  activity(invoiceId, page) {
    return Backend.get(`/invoices/${invoiceId}/activity`, { params: { page } });
  },
  delete(invoiceId) {
    return Backend.delete(`/invoices/${invoiceId}`);
  },
};
